import React, { useRef, useState } from 'react';
import { Datagrid, TextField, useRefresh } from 'react-admin';

import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import { DialogoConfirmacao } from '../../Components';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import ListPageTabbed from '../../Components/ReactAdmin/List/ListPageTabbed';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { PRIMARY_COLOR } from '../../utils';
import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils/constants';
import { PERMISSAO_TELA_PERFIS } from '../../utils/dadosTelas';
import DialogoCreateEdit from './DialogoCreateEdit';
import Filter from './Filter';

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: PRIMARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

const tabs = [
  { id: 'ativos', name: 'Ativos', filter: { status: STATUS_ATIVO } },
  { id: 'inativos', name: 'Inativos', filter: { status: STATUS_INATIVO } },
];

const List = (props) => {
  const refDialogoConfirmacao = useRef(null);
  const refresh = useRefresh();
  const classes2 = useStyles();
  const [dialogo, setDialogo] = useState({
    open: false,
    id: null,
  });

  function handleCriar() {
    setDialogo({
      open: true,
      id: null,
    });
  }

  function handleEdit({ id }) {
    setDialogo({
      open: true,
      id,
    });
  }

  async function ativar(id) {
    //await api.put(`/enderecos_exposicao_mercadorias/status/ativar/${id}`);
    handleClose();
  }
  async function desativar(id) {
    //await api.put(`/enderecos_exposicao_mercadorias/status/inativar/${id}`);
    handleClose();
  }
  async function deletar(id) {
    //await api.put(`/enderecos_exposicao_mercadorias/status/deletar/${id}`);
    handleClose();
  }

  async function handleConfirma({ id, codigo }) {
    switch (codigo) {
      case 1:
        return ativar(id);
      case 2:
        return desativar(id);
      case 3:
        return deletar(id);
      default:
    }
  }

  const handleClose = () => {
    refresh();
  };

  const toolbarActions = <ActionsList handleCriar={handleCriar} {...props} />;

  function handleAtivar(id) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'REATIVAR PERFIL DE ACESSO',
        'Tem certeza que deseja reativar?',
        {
          id,
          codigo: 1,
        },
      );
    }
  }

  function handleInativar(id) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'INATIVAR PERFIL DE ACESSO',
        'Tem certeza que deseja inativar?',
        {
          id,
          codigo: 2,
        },
      );
    }
  }

  function handelDeletar(id) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'DELETAR PERFIL DE ACESSO',
        'Tem certeza que deseja deletar?',
        {
          id,
          codigo: 3,
        },
      );
    }
  }

  const renderGrid = ({ listProps, classes, listContext }) => (
    <Datagrid {...props}>
      <TextField
        source="nome"
        label="Nome"
        headerClassName={classes2.dataHeader}
        cellClassName={classes2.dataCell}
        sortable={false}
      />
      <TextField
        source="descricao"
        label="Descrição"
        headerClassName={classes2.dataHeader}
        cellClassName={classes2.dataCell}
        sortable={false}
      />
      <ActionsField
        textAlign="right"
        label="Ações"
        sortable={false}
        headerClassName={classes2.dataHeader}
        cellClassName={classes2.dataCell}
        actions={[
          {
            title: 'Editar',
            icon: <EditOutlinedIcon />,
            show: () => true,
            onClick: (r) => handleEdit(r),
          },
          {
            title: 'Ativar',
            icon: <CheckCircleOutlineIcon />,
            show: (r) => r.status === STATUS_INATIVO,
            onClick: (r) => handleAtivar(r.id),
          },
          {
            title: 'Desativar',
            icon: <ClearIcon />,
            show: (r) => r.status === STATUS_ATIVO,
            onClick: (r) => handleInativar(r.id),
          },
          {
            title: 'Excluir',
            icon: <DeleteOutlineIcon />,
            show: (r) => r.status === STATUS_INATIVO,
            onClick: (r) => handelDeletar(r.id),
          },
        ]}
      />
    </Datagrid>
  );

  return (
    <>
      <ListPageTabbed
        title="Perfis de Acesso"
        filters={<Filter />}
        toolbarActions={toolbarActions}
        renderGrid={renderGrid}
        perPage={50}
        tabs={tabs}
        filterDefaultValues={{ status: STATUS_ATIVO }}
        listProps={{ sort: { field: 'id', order: 'asc' }, ...props }}
      />

      <DialogoConfirmacao
        ref={refDialogoConfirmacao}
        handleConfirma={handleConfirma}
      />
      <DialogoCreateEdit
        open={dialogo.open}
        id={dialogo.id}
        onClose={() => {
          setDialogo({
            open: false,
            id: null,
          });
          handleClose();
        }}
        isDialogoConfirmacaoActions
      />
    </>
  );
};

function Wrapper(props) {
  return (
    <ProtegerPagina permissao={PERMISSAO_TELA_PERFIS}>
      <List {...props} />
    </ProtegerPagina>
  );
}

export default Wrapper;
